import { render, staticRenderFns } from "./a-product-sample.vue?vue&type=template&id=88ea3f62&"
import script from "./a-product-sample.vue?vue&type=script&lang=js&"
export * from "./a-product-sample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports